// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".interval-div{display:flex;align-items:center;justify-content:center}.interval-div .el-input-number{width:100px!important}.list-div .el-input{width:auto}.list-div .el-image{height:130px;width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
